import { Component } from 'react'
import * as h from 'h'

import styles from './styles.scss'

export default class DownloadPrintablePDF extends Component {
  render () {
    const { href } = this.props
    return h.a({
      href,
      target: '_blank',
      rel: 'noopener noreferrer',
      ...h.ca(styles.downloadPrintablePDF)
    },
      h.icon({ name: 'download', ...h.ca(styles.downloadIcon) }),
      'Download Printable PDF')
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/IntellectualPropertyView/DownloadPrintablePDF.js